/**
 * OwnerDashboardRepository
 * 오너 대시보드 API 호출 레이어
 */
import { ownerApi } from '../../../services/api';
import type { DashboardStats } from '../models/OwnerDashboard';

/**
 * OwnerDashboardRepository 클래스
 * 대시보드 관련 API 호출 담당
 */
export class OwnerDashboardRepository {
  /**
   * 대시보드 통계 데이터 조회
   */
  async getDashboardStats(): Promise<DashboardStats> {
    try {
      const stats = await ownerApi.getDashboardStats();
      return stats;
    } catch (error) {
      console.error('❌ Failed to load dashboard stats:', error);
      throw error;
    }
  }

  /**
   * 전체 좌석 해제 (관리자 액션)
   */
  async releaseAllSeats(): Promise<void> {
    try {
      // TODO: API 구현 필요
      await new Promise((resolve) => setTimeout(resolve, 500));
    } catch (error) {
      console.error('❌ Failed to release all seats:', error);
      throw error;
    }
  }

  /**
   * 긴급 알림 발송 (관리자 액션)
   */
  async sendEmergencyAlert(message: string): Promise<void> {
    try {
      // TODO: API 구현 필요
      await new Promise((resolve) => setTimeout(resolve, 500));
    } catch (error) {
      console.error('❌ Failed to send emergency alert:', error);
      throw error;
    }
  }

  /**
   * 시스템 상태 확인
   */
  async checkSystemStatus(): Promise<{
    status: string;
    connectionStatus: string;
    activeSeats: number;
  }> {
    try {
      // TODO: API 구현 필요
      await new Promise((resolve) => setTimeout(resolve, 500));
      return {
        status: '정상',
        connectionStatus: 'connected',
        activeSeats: 0,
      };
    } catch (error) {
      console.error('❌ Failed to check system status:', error);
      throw error;
    }
  }
}

/**
 * OwnerDashboardRepository 싱글톤 인스턴스
 */
export const ownerDashboardRepository = new OwnerDashboardRepository();
